import { render } from "./AjaxSelectField.vue?vue&type=template&id=2b640efb"
import script from "./AjaxSelectField.vue?vue&type=script&lang=js"
export * from "./AjaxSelectField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AjaxSelectField.vue"]])

export default __exports__